// Generated from Natural Earth 1:110m Admin 0 Countries (public domain) — do not edit by hand.
// Lower-cased country name or alias → Natural Earth ADM0_A3 code (the `code` property in
// public/geo/countries-110m.geojson).
export const countryCodesByName: Record<string, string> = {
    "afghanistan": "AFG",
    "albania": "ALB",
    "algeria": "DZA",
    "angola": "AGO",
    "antarctica": "ATA",
    "arab republic of egypt": "EGY",
    "argentina": "ARG",
    "argentine republic": "ARG",
    "armenia": "ARM",
    "australia": "AUS",
    "austria": "AUT",
    "azerbaijan": "AZE",
    "bahamas": "BHS",
    "bangladesh": "BGD",
    "belarus": "BLR",
    "belgium": "BEL",
    "belize": "BLZ",
    "benin": "BEN",
    "bhutan": "BTN",
    "bolivarian republic of venezuela": "VEN",
    "bolivia": "BOL",
    "bosnia and herz.": "BIH",
    "bosnia and herzegovina": "BIH",
    "botswana": "BWA",
    "brazil": "BRA",
    "britain": "GBR",
    "brunei": "BRN",
    "brunei darussalam": "BRN",
    "bulgaria": "BGR",
    "burkina faso": "BFA",
    "burma": "MMR",
    "burundi": "BDI",
    "cambodia": "KHM",
    "cameroon": "CMR",
    "canada": "CAN",
    "central african rep.": "CAF",
    "central african republic": "CAF",
    "chad": "TCD",
    "chile": "CHL",
    "china": "CHN",
    "co-operative republic of guyana": "GUY",
    "colombia": "COL",
    "commonwealth of australia": "AUS",
    "commonwealth of puerto rico": "PRI",
    "commonwealth of the bahamas": "BHS",
    "congo": "COG",
    "congo-brazzaville": "COG",
    "congo-kinshasa": "COD",
    "costa rica": "CRI",
    "cote d'ivoire": "CIV",
    "croatia": "HRV",
    "cuba": "CUB",
    "cyprus": "CYP",
    "czech republic": "CZE",
    "czechia": "CZE",
    "côte d'ivoire": "CIV",
    "dem. rep. congo": "COD",
    "dem. rep. korea": "PRK",
    "democratic people's republic of korea": "PRK",
    "democratic republic of congo": "COD",
    "democratic republic of the congo": "COD",
    "democratic republic of timor-leste": "TLS",
    "democratic socialist republic of sri lanka": "LKA",
    "denmark": "DNK",
    "djibouti": "DJI",
    "dominican rep.": "DOM",
    "dominican republic": "DOM",
    "dr congo": "COD",
    "drc": "COD",
    "east timor": "TLS",
    "ecuador": "ECU",
    "egypt": "EGY",
    "el salvador": "SLV",
    "england": "GBR",
    "eq. guinea": "GNQ",
    "equatorial guinea": "GNQ",
    "eritrea": "ERI",
    "estonia": "EST",
    "eswatini": "SWZ",
    "ethiopia": "ETH",
    "falkland is.": "FLK",
    "falkland islands": "FLK",
    "falkland islands / malvinas": "FLK",
    "federal democratic republic of ethiopia": "ETH",
    "federal republic of germany": "DEU",
    "federal republic of nigeria": "NGA",
    "federal republic of somalia": "SOM",
    "federative republic of brazil": "BRA",
    "fiji": "FJI",
    "finland": "FIN",
    "fr. s. antarctic lands": "ATF",
    "france": "FRA",
    "french republic": "FRA",
    "french southern and antarctic lands": "ATF",
    "gabon": "GAB",
    "gabonese republic": "GAB",
    "gambia": "GMB",
    "georgia": "GEO",
    "germany": "DEU",
    "ghana": "GHA",
    "grand duchy of luxembourg": "LUX",
    "great britain": "GBR",
    "greece": "GRC",
    "greenland": "GRL",
    "guatemala": "GTM",
    "guinea": "GIN",
    "guinea-bissau": "GNB",
    "guyana": "GUY",
    "haiti": "HTI",
    "hashemite kingdom of jordan": "JOR",
    "hellenic republic": "GRC",
    "honduras": "HND",
    "hungary": "HUN",
    "iceland": "ISL",
    "independent state of papua new guinea": "PNG",
    "india": "IND",
    "indonesia": "IDN",
    "iran": "IRN",
    "iran (islamic republic of)": "IRN",
    "iraq": "IRQ",
    "ireland": "IRL",
    "islamic republic of iran": "IRN",
    "islamic republic of mauritania": "MRT",
    "islamic republic of pakistan": "PAK",
    "islamic state of afghanistan": "AFG",
    "israel": "ISR",
    "italian republic": "ITA",
    "italy": "ITA",
    "ivory coast": "CIV",
    "jamaica": "JAM",
    "japan": "JPN",
    "jordan": "JOR",
    "kazakhstan": "KAZ",
    "kenya": "KEN",
    "kingdom of belgium": "BEL",
    "kingdom of bhutan": "BTN",
    "kingdom of cambodia": "KHM",
    "kingdom of denmark": "DNK",
    "kingdom of eswatini": "SWZ",
    "kingdom of lesotho": "LSO",
    "kingdom of morocco": "MAR",
    "kingdom of norway": "NOR",
    "kingdom of saudi arabia": "SAU",
    "kingdom of spain": "ESP",
    "kingdom of sweden": "SWE",
    "kingdom of thailand": "THA",
    "kingdom of the netherlands": "NLD",
    "kosovo": "KOS",
    "kuwait": "KWT",
    "kyrgyz republic": "KGZ",
    "kyrgyzstan": "KGZ",
    "lao pdr": "LAO",
    "lao people's democratic republic": "LAO",
    "laos": "LAO",
    "latvia": "LVA",
    "lebanese republic": "LBN",
    "lebanon": "LBN",
    "lesotho": "LSO",
    "liberia": "LBR",
    "libya": "LBY",
    "lithuania": "LTU",
    "luxembourg": "LUX",
    "madagascar": "MDG",
    "malawi": "MWI",
    "malaysia": "MYS",
    "mali": "MLI",
    "mauritania": "MRT",
    "mexico": "MEX",
    "moldova": "MDA",
    "mongolia": "MNG",
    "montenegro": "MNE",
    "morocco": "MAR",
    "mozambique": "MOZ",
    "myanmar": "MMR",
    "n. cyprus": "CYN",
    "namibia": "NAM",
    "negara brunei darussalam": "BRN",
    "nepal": "NPL",
    "netherlands": "NLD",
    "new caledonia": "NCL",
    "new zealand": "NZL",
    "nicaragua": "NIC",
    "niger": "NER",
    "nigeria": "NGA",
    "north korea": "PRK",
    "north macedonia": "MKD",
    "northern cyprus": "CYN",
    "norway": "NOR",
    "oman": "OMN",
    "oriental republic of uruguay": "URY",
    "pakistan": "PAK",
    "palestine": "PSX",
    "panama": "PAN",
    "papua new guinea": "PNG",
    "paraguay": "PRY",
    "people's democratic republic of algeria": "DZA",
    "people's republic of angola": "AGO",
    "people's republic of bangladesh": "BGD",
    "people's republic of china": "CHN",
    "peru": "PER",
    "philippines": "PHL",
    "plurinational state of bolivia": "BOL",
    "poland": "POL",
    "portugal": "PRT",
    "portuguese republic": "PRT",
    "puerto rico": "PRI",
    "qatar": "QAT",
    "republic of albania": "ALB",
    "republic of armenia": "ARM",
    "republic of austria": "AUT",
    "republic of azerbaijan": "AZE",
    "republic of belarus": "BLR",
    "republic of benin": "BEN",
    "republic of botswana": "BWA",
    "republic of bulgaria": "BGR",
    "republic of burundi": "BDI",
    "republic of cameroon": "CMR",
    "republic of chad": "TCD",
    "republic of chile": "CHL",
    "republic of colombia": "COL",
    "republic of congo": "COG",
    "republic of costa rica": "CRI",
    "republic of croatia": "HRV",
    "republic of cuba": "CUB",
    "republic of cyprus": "CYP",
    "republic of djibouti": "DJI",
    "republic of ecuador": "ECU",
    "republic of el salvador": "SLV",
    "republic of equatorial guinea": "GNQ",
    "republic of estonia": "EST",
    "republic of fiji": "FJI",
    "republic of finland": "FIN",
    "republic of ghana": "GHA",
    "republic of guatemala": "GTM",
    "republic of guinea": "GIN",
    "republic of guinea-bissau": "GNB",
    "republic of haiti": "HTI",
    "republic of honduras": "HND",
    "republic of hungary": "HUN",
    "republic of iceland": "ISL",
    "republic of india": "IND",
    "republic of indonesia": "IDN",
    "republic of iraq": "IRQ",
    "republic of ivory coast": "CIV",
    "republic of kazakhstan": "KAZ",
    "republic of kenya": "KEN",
    "republic of korea": "KOR",
    "republic of kosovo": "KOS",
    "republic of latvia": "LVA",
    "republic of liberia": "LBR",
    "republic of lithuania": "LTU",
    "republic of madagascar": "MDG",
    "republic of malawi": "MWI",
    "republic of mali": "MLI",
    "republic of moldova": "MDA",
    "republic of mozambique": "MOZ",
    "republic of namibia": "NAM",
    "republic of nicaragua": "NIC",
    "republic of niger": "NER",
    "republic of north macedonia": "MKD",
    "republic of panama": "PAN",
    "republic of paraguay": "PRY",
    "republic of peru": "PER",
    "republic of poland": "POL",
    "republic of rwanda": "RWA",
    "republic of senegal": "SEN",
    "republic of serbia": "SRB",
    "republic of sierra leone": "SLE",
    "republic of slovenia": "SVN",
    "republic of somaliland": "SOL",
    "republic of south africa": "ZAF",
    "republic of south sudan": "SDS",
    "republic of suriname": "SUR",
    "republic of tajikistan": "TJK",
    "republic of the congo": "COG",
    "republic of the gambia": "GMB",
    "republic of the philippines": "PHL",
    "republic of the sudan": "SDN",
    "republic of the union of myanmar": "MMR",
    "republic of trinidad and tobago": "TTO",
    "republic of tunisia": "TUN",
    "republic of turkey": "TUR",
    "republic of uganda": "UGA",
    "republic of uzbekistan": "UZB",
    "republic of vanuatu": "VUT",
    "republic of yemen": "YEM",
    "republic of zambia": "ZMB",
    "republic of zimbabwe": "ZWE",
    "romania": "ROU",
    "russia": "RUS",
    "russian federation": "RUS",
    "rwanda": "RWA",
    "s. sudan": "SDS",
    "sahrawi arab democratic republic": "SAH",
    "saudi arabia": "SAU",
    "senegal": "SEN",
    "serbia": "SRB",
    "sierra leone": "SLE",
    "slovak republic": "SVK",
    "slovakia": "SVK",
    "slovenia": "SVN",
    "socialist republic of vietnam": "VNM",
    "solomon is.": "SLB",
    "solomon islands": "SLB",
    "somalia": "SOM",
    "somaliland": "SOL",
    "south africa": "ZAF",
    "south korea": "KOR",
    "south sudan": "SDS",
    "spain": "ESP",
    "sri lanka": "LKA",
    "state of eritrea": "ERI",
    "state of israel": "ISR",
    "state of kuwait": "KWT",
    "state of qatar": "QAT",
    "sudan": "SDN",
    "sultanate of oman": "OMN",
    "suriname": "SUR",
    "swaziland": "SWZ",
    "sweden": "SWE",
    "swiss confederation": "CHE",
    "switzerland": "CHE",
    "syria": "SYR",
    "syrian arab republic": "SYR",
    "taiwan": "TWN",
    "tajikistan": "TJK",
    "tanzania": "TZA",
    "territory of the french southern and antarctic lands": "ATF",
    "thailand": "THA",
    "the bahamas": "BHS",
    "the gambia": "GMB",
    "timor-leste": "TLS",
    "togo": "TGO",
    "togolese republic": "TGO",
    "trinidad and tobago": "TTO",
    "tunisia": "TUN",
    "turkey": "TUR",
    "turkish republic of northern cyprus": "CYN",
    "turkmenistan": "TKM",
    "u.s.": "USA",
    "u.s.a.": "USA",
    "uganda": "UGA",
    "uk": "GBR",
    "ukraine": "UKR",
    "united arab emirates": "ARE",
    "united kingdom": "GBR",
    "united kingdom of great britain and northern ireland": "GBR",
    "united mexican states": "MEX",
    "united republic of tanzania": "TZA",
    "united states": "USA",
    "united states of america": "USA",
    "uruguay": "URY",
    "usa": "USA",
    "uzbekistan": "UZB",
    "vanuatu": "VUT",
    "venezuela": "VEN",
    "viet nam": "VNM",
    "vietnam": "VNM",
    "w. sahara": "SAH",
    "west bank and gaza": "PSX",
    "western sahara": "SAH",
    "yemen": "YEM",
    "zambia": "ZMB",
    "zimbabwe": "ZWE",
};

// ADM0_A3 code → display name.
export const countryNamesByCode: Record<string, string> = {
    AFG: "Afghanistan",
    AGO: "Angola",
    ALB: "Albania",
    ARE: "United Arab Emirates",
    ARG: "Argentina",
    ARM: "Armenia",
    ATA: "Antarctica",
    ATF: "Fr. S. Antarctic Lands",
    AUS: "Australia",
    AUT: "Austria",
    AZE: "Azerbaijan",
    BDI: "Burundi",
    BEL: "Belgium",
    BEN: "Benin",
    BFA: "Burkina Faso",
    BGD: "Bangladesh",
    BGR: "Bulgaria",
    BHS: "Bahamas",
    BIH: "Bosnia and Herz.",
    BLR: "Belarus",
    BLZ: "Belize",
    BOL: "Bolivia",
    BRA: "Brazil",
    BRN: "Brunei",
    BTN: "Bhutan",
    BWA: "Botswana",
    CAF: "Central African Rep.",
    CAN: "Canada",
    CHE: "Switzerland",
    CHL: "Chile",
    CHN: "China",
    CIV: "Côte d'Ivoire",
    CMR: "Cameroon",
    COD: "Dem. Rep. Congo",
    COG: "Congo",
    COL: "Colombia",
    CRI: "Costa Rica",
    CUB: "Cuba",
    CYN: "N. Cyprus",
    CYP: "Cyprus",
    CZE: "Czechia",
    DEU: "Germany",
    DJI: "Djibouti",
    DNK: "Denmark",
    DOM: "Dominican Rep.",
    DZA: "Algeria",
    ECU: "Ecuador",
    EGY: "Egypt",
    ERI: "Eritrea",
    ESP: "Spain",
    EST: "Estonia",
    ETH: "Ethiopia",
    FIN: "Finland",
    FJI: "Fiji",
    FLK: "Falkland Is.",
    FRA: "France",
    GAB: "Gabon",
    GBR: "United Kingdom",
    GEO: "Georgia",
    GHA: "Ghana",
    GIN: "Guinea",
    GMB: "Gambia",
    GNB: "Guinea-Bissau",
    GNQ: "Eq. Guinea",
    GRC: "Greece",
    GRL: "Greenland",
    GTM: "Guatemala",
    GUY: "Guyana",
    HND: "Honduras",
    HRV: "Croatia",
    HTI: "Haiti",
    HUN: "Hungary",
    IDN: "Indonesia",
    IND: "India",
    IRL: "Ireland",
    IRN: "Iran",
    IRQ: "Iraq",
    ISL: "Iceland",
    ISR: "Israel",
    ITA: "Italy",
    JAM: "Jamaica",
    JOR: "Jordan",
    JPN: "Japan",
    KAZ: "Kazakhstan",
    KEN: "Kenya",
    KGZ: "Kyrgyzstan",
    KHM: "Cambodia",
    KOR: "South Korea",
    KOS: "Kosovo",
    KWT: "Kuwait",
    LAO: "Laos",
    LBN: "Lebanon",
    LBR: "Liberia",
    LBY: "Libya",
    LKA: "Sri Lanka",
    LSO: "Lesotho",
    LTU: "Lithuania",
    LUX: "Luxembourg",
    LVA: "Latvia",
    MAR: "Morocco",
    MDA: "Moldova",
    MDG: "Madagascar",
    MEX: "Mexico",
    MKD: "North Macedonia",
    MLI: "Mali",
    MMR: "Myanmar",
    MNE: "Montenegro",
    MNG: "Mongolia",
    MOZ: "Mozambique",
    MRT: "Mauritania",
    MWI: "Malawi",
    MYS: "Malaysia",
    NAM: "Namibia",
    NCL: "New Caledonia",
    NER: "Niger",
    NGA: "Nigeria",
    NIC: "Nicaragua",
    NLD: "Netherlands",
    NOR: "Norway",
    NPL: "Nepal",
    NZL: "New Zealand",
    OMN: "Oman",
    PAK: "Pakistan",
    PAN: "Panama",
    PER: "Peru",
    PHL: "Philippines",
    PNG: "Papua New Guinea",
    POL: "Poland",
    PRI: "Puerto Rico",
    PRK: "North Korea",
    PRT: "Portugal",
    PRY: "Paraguay",
    PSX: "Palestine",
    QAT: "Qatar",
    ROU: "Romania",
    RUS: "Russia",
    RWA: "Rwanda",
    SAH: "W. Sahara",
    SAU: "Saudi Arabia",
    SDN: "Sudan",
    SDS: "S. Sudan",
    SEN: "Senegal",
    SLB: "Solomon Is.",
    SLE: "Sierra Leone",
    SLV: "El Salvador",
    SOL: "Somaliland",
    SOM: "Somalia",
    SRB: "Serbia",
    SUR: "Suriname",
    SVK: "Slovakia",
    SVN: "Slovenia",
    SWE: "Sweden",
    SWZ: "eSwatini",
    SYR: "Syria",
    TCD: "Chad",
    TGO: "Togo",
    THA: "Thailand",
    TJK: "Tajikistan",
    TKM: "Turkmenistan",
    TLS: "Timor-Leste",
    TTO: "Trinidad and Tobago",
    TUN: "Tunisia",
    TUR: "Turkey",
    TWN: "Taiwan",
    TZA: "Tanzania",
    UGA: "Uganda",
    UKR: "Ukraine",
    URY: "Uruguay",
    USA: "United States of America",
    UZB: "Uzbekistan",
    VEN: "Venezuela",
    VNM: "Vietnam",
    VUT: "Vanuatu",
    YEM: "Yemen",
    ZAF: "South Africa",
    ZMB: "Zambia",
    ZWE: "Zimbabwe",
};
